/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrfToken;
window.axios.defaults.headers.common['locale'] = window.locale;


window.Vue = require('vue').default;
window.Vuex = require('vuex');
window._ = require('lodash');

import Notifications from 'vue-notification'

Vue.prototype._ = _
Vue.use(Vuex);
Vue.use(Notifications);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

var components = {
    'search-component': 'SearchComponent',
    'cart-component': 'CartComponent',
    'cart-summary-component': 'CartSummaryComponent',
    'cart-vouchers-component': 'CartVouchersComponent',
    'product-main-component': 'ProductMainComponent',
    'account-rewards-points-component': 'AccountRewardsPointsComponent',
    'add-to-cart-component': 'AddToCartComponent',
    'notifications-component': 'NotificationsComponent',
    'cart-dropdown-component': 'CartDropdownComponent',
    'checkout-component': 'CheckoutComponent',
    'product-block-component': 'ProductBlockComponent',
    'wishlist-icon-component': 'WishlistIconComponent',
    'wishlist-nav-component': 'WishlistNavComponent',
    'wishlist-component': 'WishlistComponent',
    'blog-component': 'BlogComponent',
}

Object.keys(components).forEach(key => {
    try {
        Vue.component(key, require('../../../../../resources/js/components/'+components[key]+'.vue').default);
    } catch (e) {
        Vue.component(key, require('./components/'+components[key]+'.vue').default);
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.mixin({
    methods: {
        url(path) {
            return app_url+'/'+(locale != config.default_locale ? locale+'/' : '')+path
        },
        amountWithCurrency(amount, considerDecimals = true) {
            if (considerDecimals && config.currency_decimals) {
                amount = amount / 100
            }
            if (amount) {
                amount = config.currency_decimals ? amount.toLocaleString(locale, { minimumFractionDigits: 2 }) : amount.toLocaleString()
            }
            if (config.currency_position == 'prefix') {
                return config.currency_symbol+amount
            } else {
                return amount+config.currency_symbol
            }
        },
        stripTags(str) {
            return str.replace(/(<([^>]+)>)/gi, "")
        },
        truncateText(text, length = 60, omission = '[...]') {
            return _.truncate(text, {length: length, omission: omission})
        },
        __(file, ref, replace = {})
        {
            var translation = window.t[file][ref]
            if (replace) {
                for (var placeholder in replace) {
                    translation = translation.replace(`:${placeholder}`, replace[placeholder]);
                }
            }
            return translation;
        },
        pluck(array, key) {
            return array.map(o => o[key]);
        }
    }
})

const app = new Vue({
    el: '#app',
})


const share = document.querySelector('#share');
// Share must be triggered by "user activation"
if(share) {
    share.addEventListener('click', async (event) => {
        event.preventDefault()
        try {
            await navigator.share({
                title: share.dataset.title,
                text: share.dataset.description,
                url: share.dataset.url
            })
        } catch(err) {
            console.log(err);
        }
    });
}
const shareCopy = document.querySelector('#share-copy');
if(shareCopy) {
    shareCopy.addEventListener('click', async (event) => {
        event.preventDefault()
        try {
            await navigator.clipboard.writeText(shareCopy.dataset.url).then(function() {
                Vue.notify({text: t.global.copy_success, type: 'success'})
            });
        } catch (e) {
            console.log(e);
        }
    })
}

// import Alpine from 'alpinejs'
// window.Alpine = Alpine
// Alpine.start()
